import React from 'react';
import { MapPinIcon, HandshakeIcon, ShieldCheckIcon, HeadsetIcon, DollarSignIcon, FileCheckIcon } from 'lucide-react';
export function WhyUCenSysSection() {
  const reasons = [{
    icon: <MapPinIcon className="w-6 h-6" data-id="element-304" />,
    title: 'Atlanta-Based',
    description: 'Your data stays local. Benefit from geographic proximity, reduced latency, and strict adherence to regional compliance requirements.'
  }, {
    icon: <HandshakeIcon className="w-6 h-6" data-id="element-305" />,
    title: 'IBM Cloud Partnership',
    description: 'As a certified partner, we provide seamless integration and expert management of IBM Cloud enterprise solutions.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6" data-id="element-306" />,
    title: 'Enterprise SLAs',
    description: 'We back our infrastructure with an ironclad 99.99% uptime guarantee, ensuring your mission-critical applications stay online.'
  }, {
    icon: <HeadsetIcon className="w-6 h-6" data-id="element-307" />,
    title: 'Dedicated Support',
    description: 'Access our 24/7 expert engineering team directly. No tiered support desks—just direct access to infrastructure specialists.'
  }, {
    icon: <DollarSignIcon className="w-6 h-6" data-id="element-308" />,
    title: 'Flexible Pricing',
    description: 'Transparent, predictable pricing models across colocation, managed hosting, and hybrid cloud deployments.'
  }, {
    icon: <FileCheckIcon className="w-6 h-6" data-id="element-309" />,
    title: 'Compliance Ready',
    description: 'Our facilities and processes are SSAE 18 compliant and SOC 2 ready, meeting the strictest enterprise regulatory standards.'
  }];
  return <section className="py-24 lg:py-32 bg-section-fade border-t border-border-color" data-id="element-310">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-312">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6" data-id="element-313">
            Why Enterprise Teams Choose UCenSys
          </h2>
          <p className="text-lg font-body text-text-secondary" data-id="element-314">
            We combine the scale and reliability of global cloud providers with
            the dedicated support and security of a private data center.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-315">
          {reasons.map((reason, index) => <div key={index} className="bg-ucensys-navy border border-border-color rounded-xl p-8 flex gap-5 hover:bg-ucensys-card transition-colors" data-id="element-316">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-ucensys-teal/10 flex items-center justify-center text-ucensys-teal" data-id="element-317">
                {reason.icon}
              </div>
              <div data-id="element-318">
                <h3 className="text-lg font-heading font-semibold text-white mb-2" data-id="element-319">
                  {reason.title}
                </h3>
                <p className="text-sm font-body text-text-muted leading-relaxed" data-id="element-320">
                  {reason.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}